import './styles.css';
import LearnSession from "../../common/LearnSession";
import {useState, useEffect} from 'react';
import { useLocation } from 'react-router-dom';
import {useIsSmallScreen, useIsMediumScreen} from '../../hooks/screenSizeHooks';
import  learnMetaData from './learnMetaData';
import PageNotFound from '../../common/PageNotFound';
import { Typography } from '@mui/material';
import SEO from '../../common/SEO';

const LearnPage = () => {
	const [dataIndex,setDataIndex ] = useState(0);
	const [dataArray, setDataArray] = useState(undefined)
	const [keyName, setKeyName] = useState('');
	const location = useLocation();
	const isSmallScreen = useIsSmallScreen();
	const isMediumScreen = useIsMediumScreen();

	useEffect(() => {
		if(!!learnMetaData[location.pathname]) {
				setDataIndex(0);
				setDataArray(learnMetaData[location.pathname].learnData)
				const findKeyFromTitle = learnMetaData[location.pathname].learnTitle.slice(7,16);
				setKeyName(findKeyFromTitle)
		} else {
			setDataArray(undefined)
		}
 	 }, [ location.pathname])


	return (
		<>
			<SEO pageName="learn" />
			{!dataArray?
				<PageNotFound />
				:
				<>
					<Typography variant="h5" className='learnPageText'>{learnMetaData[location.pathname].learnTitle}</Typography>
					<Typography variant="subtitle1"  className='learnPageText'>{learnMetaData[location.pathname].subText}</Typography >
						<LearnSession 
							dataArray={dataArray}
							dataIndex={dataIndex}
							setDataIndex={setDataIndex}
							isSmallScreen={isSmallScreen}
							isMediumScreen={isMediumScreen}
							pathname={location.pathname}
							keyName={keyName}
							
						/>
				</>		
			}
		</>
	)
}

export default LearnPage;